import React, { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { Box, Grid, Paper, Divider, TextField } from "@mui/material";

import { Helmet } from "react-helmet";

import SVMProgrammingLang from "./SVMProgrammingLang";
import SVMApplications from "./SVMApplications";
import SVMTools from "./SVMTools";
import SVMSystemTools from "./SVMSystemtools";

const commonStyles = {
  bgcolor: "background.paper",
  m: 1,
  display: "flex",
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 2,
  paddingBottom: 2,
  borderRadius: 1,
};

export default function InstanceConfig(props) {
  const {
    state1,
    setState1,
    svminstancetype,
    setProgrammingapps,
    setSystemtools,
    setNormalapps,
    setDevopsapps,
    setDevopsport,
    setNormalport,
  } = props;

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState1((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  var currentTime = new Date();
  var currentOffset = currentTime.getTimezoneOffset();
  var ISTOffset = 330; // IST offset UTC +5:30
  var ISTTime = new Date(
    currentTime.getTime() + (ISTOffset + currentOffset) * 60000
  );
  var hoursIST = ISTTime.getHours();
  var minutesIST = ISTTime.getMinutes();
  var currentDate = new Date().toISOString().substring(0, 10);

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>

      <Box sx={{ pb: 0, pt: 4 }}>
        <Typography
          style={{ fontWeight: "500", fontSize: "16px" }}
          gutterBottom
        >
          Configuration
        </Typography>
        <Divider />
      </Box>
      <Paper sx={{ ...commonStyles, variant: "outlined" }}>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Instance Type"
              name={`instance_type`}
              id={`instance_type`}
              onChange={handleChange}
              value={state1.instance_type}
              required
              autoComplete="name"
              select
              SelectProps={{ native: true }}
            >
              {" "}
              <option key="" value=""></option>
              {svminstancetype.map((svminstancetype) => {
                return (
                  <React.Fragment>
                    <option value={svminstancetype.name}>
                      {svminstancetype.title}
                    </option>
                  </React.Fragment>
                );
              })}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Instance_storage"
              name={`instance_storage`}
              id={`instance_storage`}
              onChange={handleChange}
              value={state1.instance_storage}
              required
              select
              SelectProps={{ native: true }}
              autoComplete="name"
            >
              {" "}
              <option key="" value=""></option>
              <option key="200" value="200">
                200gb
              </option>
              <option key="500" value="500">
                500gb
              </option>
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="OS-Type"
              name={`ostype`}
              id={`ostype`}
              onChange={handleChange}
              value={state1.ostype}
              required
              select
              SelectProps={{ native: true }}
              autoComplete="name"
            >
              {" "}
              <option key="linux" value="linux">
                Linux
              </option>
              <option key="windows" value="windows">
                Windows
              </option>
            </TextField>
          </Grid>

          {state1.ostype === "linux" ? (
            <React.Fragment>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Linux-Type"
                  name={`linux_type`}
                  id={`linux_type`}
                  onChange={handleChange}
                  value={state1.linux_type}
                  required
                  select
                  SelectProps={{ native: true }}
                  autoComplete="name"
                >
                  {" "}
                  <option key="" value=""></option>
                  <option key="centos7" value="centos7">
                    Centos7
                  </option>
                  <option key="centos8" value="centos8">
                    Centos8
                  </option>
                  {/* <option key="ubuntu18" value="ubuntu18">
                    Ubuntu18
                  </option> */}
                  <option key="ubuntu20" value="ubuntu20">
                    Ubuntu20
                  </option>
                  <option key="ubuntu22" value="ubuntu22">
                    Ubuntu22
                  </option>
                  <option key="ubuntu24" value="ubuntu24">
                    Ubuntu24
                  </option>
                </TextField>
              </Grid>
              {state1.linux_type === "centos7" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="centos7"
                        appsetFormFields={setNormalapps}
                        setNormalport={setNormalport}
                        appfieldIndex="apps"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="centos7"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="centos7"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="centos7"
                        appsetFormFields={setDevopsapps}
                        appfieldIndex="tools"
                        setDevopsport={setDevopsport}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : state1.linux_type === "centos8" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="centos8"
                        appsetFormFields={setNormalapps}
                        appfieldIndex="apps"
                        setNormalport={setNormalport}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="centos8"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="centos8"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="centos8"
                        appsetFormFields={setDevopsapps}
                        appfieldIndex="tools"
                        setDevopsport={setDevopsport}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )  : state1.linux_type === "ubuntu18" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="ubuntu18"
                        appsetFormFields={setNormalapps}
                        setNormalport={setNormalport}
                        appfieldIndex="apps"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="ubuntu18"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="ubuntu18"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="ubuntu18"
                        appsetFormFields={setDevopsapps}
                        setDevopsport={setDevopsport}
                        appfieldIndex="tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : state1.linux_type === "ubuntu20" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="ubuntu20"
                        appsetFormFields={setNormalapps}
                        appfieldIndex="apps"
                        setNormalport={setNormalport}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="ubuntu20"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="ubuntu20"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="ubuntu20"
                        appsetFormFields={setDevopsapps}
                        setDevopsport={setDevopsport}
                        appfieldIndex="tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : state1.linux_type === "ubuntu22" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="ubuntu22"
                        appsetFormFields={setNormalapps}
                        appfieldIndex="apps"
                        setNormalport={setNormalport}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="ubuntu22"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="ubuntu22"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="ubuntu22"
                        appsetFormFields={setDevopsapps}
                        setDevopsport={setDevopsport}
                        appfieldIndex="tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="ubuntu24"
                        appsetFormFields={setNormalapps}
                        setNormalport={setNormalport}
                        appfieldIndex="apps"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="ubuntu24"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="ubuntu24"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMTools
                        OSTYPE="ubuntu24"
                        appsetFormFields={setDevopsapps}
                        setDevopsport={setDevopsport}
                        appfieldIndex="tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          ) : state1.ostype === "windows" ? (
            <React.Fragment>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Windows-Type"
                  name={`windows_type`}
                  id={`windows_type`}
                  onChange={handleChange}
                  value={state1.windows_type}
                  required
                  select
                  SelectProps={{ native: true }}
                  autoComplete="name"
                >
                  {" "}
                  <option key="" value=""></option>
                  <option key="windows2010" value="windows10">
                    Windows10
                  </option>
                  <option key="windows2022" value="windows2022">
                    Windows2022
                  </option>
                </TextField>
              </Grid>
              {state1.windows_type === "windows10" ? (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="windows10"
                        appsetFormFields={setNormalapps}
                        setNormalport={setNormalport}
                        appfieldIndex="apps"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="windows10"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="windows10"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={6}>
                      <SVMApplications
                        OSTYPE="windows2022"
                        appsetFormFields={setNormalapps}
                        setNormalport={setNormalport}
                        appfieldIndex="apps"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMProgrammingLang
                        OSTYPE="windows2022"
                        appsetFormFields={setProgrammingapps}
                        appfieldIndex="programming"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <SVMSystemTools
                        OSTYPE="windows2022"
                        appsetFormFields={setSystemtools}
                        appfieldIndex="system_tools"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </React.Fragment>
          ) : (
            ""
          )}
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
